// Soft UI Dashboard PRO React Base Styles
import default_flag from "assets/images/flags/flat/world.png";

import abkhazia_flag from "assets/images/flags/flat/abkhazia.png";
import afghanistan_flag from "assets/images/flags/flat/afghanistan.png";
import africa_flag from "assets/images/flags/flat/africa.png";
import aland_islands_flag from "assets/images/flags/flat/aland_islands.png";
import albania_flag from "assets/images/flags/flat/albania.png";
import algeria_flag from "assets/images/flags/flat/algeria.png";
import america_flag from "assets/images/flags/flat/america.png";
import american_samoa_flag from "assets/images/flags/flat/american_samoa.png";
import andorra_flag from "assets/images/flags/flat/andorra.png";
import angola_flag from "assets/images/flags/flat/angola.png";
import anguilla_flag from "assets/images/flags/flat/anguilla.png";
import antarctica_flag from "assets/images/flags/flat/antarctica.png";
import antigua_and_barbuda_flag from "assets/images/flags/flat/antigua_and_barbuda.png";
import argentina_flag from "assets/images/flags/flat/argentina.png";
import armenia_flag from "assets/images/flags/flat/armenia.png";
import aruba_flag from "assets/images/flags/flat/aruba.png";
import asia_flag from "assets/images/flags/flat/asia.png";
import australia_flag from "assets/images/flags/flat/australia.png";
import austria_flag from "assets/images/flags/flat/austria.png";
import azerbaijan_flag from "assets/images/flags/flat/azerbaijan.png";
import azores_islands_flag from "assets/images/flags/flat/azores_islands.png";
import bahamas_flag from "assets/images/flags/flat/bahamas.png";
import bahrain_flag from "assets/images/flags/flat/bahrain.png";
import balearic_islands_flag from "assets/images/flags/flat/balearic_islands.png";
import bangladesh_flag from "assets/images/flags/flat/bangladesh.png";
import barbados_flag from "assets/images/flags/flat/barbados.png";
import basque_country_flag from "assets/images/flags/flat/basque_country.png";
import belarus_flag from "assets/images/flags/flat/belarus.png";
import belgium_flag from "assets/images/flags/flat/belgium.png";
import belize_flag from "assets/images/flags/flat/belize.png";
import benin_flag from "assets/images/flags/flat/benin.png";
import bermuda_flag from "assets/images/flags/flat/bermuda.png";
import bhutan_flag from "assets/images/flags/flat/bhutan.png";
import bolivia_flag from "assets/images/flags/flat/bolivia.png";
import bonaire_flag from "assets/images/flags/flat/bonaire.png";
import bosnia_and_herzegovina_flag from "assets/images/flags/flat/bosnia_and_herzegovina.png";
import botswana_flag from "assets/images/flags/flat/botswana.png";
import brazil_flag from "assets/images/flags/flat/brazil.png";
import british_antarctic_territory_flag from "assets/images/flags/flat/british_antarctic_territory.png";
import british_columbia_flag from "assets/images/flags/flat/british_columbia.png";
import british_indian_ocean_territory_flag from "assets/images/flags/flat/british_indian_ocean_territory.png";
import british_virgin_islands_flag from "assets/images/flags/flat/british_virgin_islands.png";
import brunei_flag from "assets/images/flags/flat/brunei.png";
import buenos_aires_flag from "assets/images/flags/flat/buenos_aires.png";
import bulgaria_flag from "assets/images/flags/flat/bulgaria.png";
import burkina_faso_flag from "assets/images/flags/flat/burkina_faso.png";
import burundi_flag from "assets/images/flags/flat/burundi.png";
import california_flag from "assets/images/flags/flat/california.png";
import cambodia_flag from "assets/images/flags/flat/cambodia.png";
import cameroon_flag from "assets/images/flags/flat/cameroon.png";
import canada_flag from "assets/images/flags/flat/canada.png";
import canary_islands_flag from "assets/images/flags/flat/canary_islands.png";
import cape_verde_flag from "assets/images/flags/flat/cape_verde.png";
import cayman_islands_flag from "assets/images/flags/flat/cayman_islands.png";
import central_african_republic_flag from "assets/images/flags/flat/central_african_republic.png";
import central_america_flag from "assets/images/flags/flat/central-america.png";
import ceuta_flag from "assets/images/flags/flat/ceuta.png";
import chad_flag from "assets/images/flags/flat/chad.png";
import chile_flag from "assets/images/flags/flat/chile.png";
import china_flag from "assets/images/flags/flat/china.png";
import chinese_taipei_flag from "assets/images/flags/flat/chinese-taipei.png";
import christmas_island_flag from "assets/images/flags/flat/christmas_island.png";
import cocos_island_flag from "assets/images/flags/flat/cocos_island.png";
import colombia_flag from "assets/images/flags/flat/colombia.png";
import commonwealth_flag from "assets/images/flags/flat/commonwealth.png";
import comoros_flag from "assets/images/flags/flat/comoros.png";
import cook_islands_flag from "assets/images/flags/flat/cook_islands.png";
import corsica_flag from "assets/images/flags/flat/corsica.png";
import costa_rica_flag from "assets/images/flags/flat/costa_rica.png";
import cote_divoire_flag from "assets/images/flags/flat/cote_divoire.png";
import croatia_flag from "assets/images/flags/flat/croatia.png";
import cuba_flag from "assets/images/flags/flat/cuba.png";
import curacao_flag from "assets/images/flags/flat/curacao.png";
import cyprus_flag from "assets/images/flags/flat/cyprus.png";
import czech_republic_flag from "assets/images/flags/flat/czech_republic.png";
import democratic_republic_of_congo_flag from "assets/images/flags/flat/democratic_republic_of_congo.png";
import denmark_flag from "assets/images/flags/flat/denmark.png";
import djibouti_flag from "assets/images/flags/flat/djibouti.png";
import dominica_flag from "assets/images/flags/flat/dominica.png";
import dominican_republic_flag from "assets/images/flags/flat/dominican_republic.png";
import east_timor_flag from "assets/images/flags/flat/east_timor.png";
import ecuador_flag from "assets/images/flags/flat/ecuador.png";
import egypt_flag from "assets/images/flags/flat/egypt.png";
import el_salvador_flag from "assets/images/flags/flat/el_salvador.png";
import england_flag from "assets/images/flags/flat/england.png";
import equatorial_guinea_flag from "assets/images/flags/flat/equatorial_guinea.png";
import eritrea_flag from "assets/images/flags/flat/eritrea.png";
import estonia_flag from "assets/images/flags/flat/estonia.png";
import ethiopia_flag from "assets/images/flags/flat/ethiopia.png";
import europe_flag from "assets/images/flags/flat/europe.png";
import european_union_flag from "assets/images/flags/flat/european_union.png";
import falkland_islands_flag from "assets/images/flags/flat/falkland_islands.png";
import faroe_islands_flag from "assets/images/flags/flat/faroe_islands.png";
import fiji_flag from "assets/images/flags/flat/fiji.png";
import finland_flag from "assets/images/flags/flat/finland.png";
import france_flag from "assets/images/flags/flat/france.png";
import french_polynesia_flag from "assets/images/flags/flat/french_polynesia.png";
import french_southern_territories_flag from "assets/images/flags/flat/french_southern_territories.png";
import gabon_flag from "assets/images/flags/flat/gabon.png";
import galapagos_islands_flag from "assets/images/flags/flat/galapagos_islands.png";
import gambia_flag from "assets/images/flags/flat/gambia.png";
import georgia_flag from "assets/images/flags/flat/georgia.png";
import germany_flag from "assets/images/flags/flat/germany.png";
import ghana_flag from "assets/images/flags/flat/ghana.png";
import gibraltar_flag from "assets/images/flags/flat/gibraltar.png";
import GoSquared_flag from "assets/images/flags/flat/GoSquared.png";
import great_britain_flag from "assets/images/flags/flat/great-britain.png";
import greece_flag from "assets/images/flags/flat/greece.png";
import greenland_flag from "assets/images/flags/flat/greenland.png";
import grenada_flag from "assets/images/flags/flat/grenada.png";
import guadeloupe_flag from "assets/images/flags/flat/guadeloupe.png";
import guam_flag from "assets/images/flags/flat/guam.png";
import guatemala_flag from "assets/images/flags/flat/guatemala.png";
import guernsey_flag from "assets/images/flags/flat/guernsey.png";
import guinea_flag from "assets/images/flags/flat/guinea.png";
import guinea_bissau_flag from "assets/images/flags/flat/guinea_bissau.png";
import guyana_flag from "assets/images/flags/flat/guyana.png";
import haiti_flag from "assets/images/flags/flat/haiti.png";
import hawaii_flag from "assets/images/flags/flat/hawaii.png";
import honduras_flag from "assets/images/flags/flat/honduras.png";
import hong_kong_flag from "assets/images/flags/flat/hong_kong.png";
import hungary_flag from "assets/images/flags/flat/hungary.png";
import iceland_flag from "assets/images/flags/flat/iceland.png";
import india_flag from "assets/images/flags/flat/india.png";
import indonesia_flag from "assets/images/flags/flat/indonesia.png";
import international_flag from "assets/images/flags/flat/international.png";
import iran_flag from "assets/images/flags/flat/iran.png";
import iraq_flag from "assets/images/flags/flat/iraq.png";
import ireland_flag from "assets/images/flags/flat/ireland.png";
import isle_of_man_flag from "assets/images/flags/flat/isle_of_man.png";
import israel_flag from "assets/images/flags/flat/israel.png";
import italy_flag from "assets/images/flags/flat/italy.png";
import ivory_coast_flag from "assets/images/flags/flat/ivory_coast.png";
import jamaica_flag from "assets/images/flags/flat/jamaica.png";
import japan_flag from "assets/images/flags/flat/japan.png";
import jersey_flag from "assets/images/flags/flat/jersey.png";
import jordan_flag from "assets/images/flags/flat/jordan.png";
import kazakhstan_flag from "assets/images/flags/flat/kazakhstan.png";
import kenya_flag from "assets/images/flags/flat/kenya.png";
import kiribati_flag from "assets/images/flags/flat/kiribati.png";
import kosovo_flag from "assets/images/flags/flat/kosovo.png";
import kuwait_flag from "assets/images/flags/flat/kuwait.png";
import kyrgyzstan_flag from "assets/images/flags/flat/kyrgyzstan.png";
import laos_flag from "assets/images/flags/flat/laos.png";
import latvia_flag from "assets/images/flags/flat/latvia.png";
import lebanon_flag from "assets/images/flags/flat/lebanon.png";
import lesotho_flag from "assets/images/flags/flat/lesotho.png";
import liberia_flag from "assets/images/flags/flat/liberia.png";
import libya_flag from "assets/images/flags/flat/libya.png";
import liechtenstein_flag from "assets/images/flags/flat/liechtenstein.png";
import lithuania_flag from "assets/images/flags/flat/lithuania.png";
import luxembourg_flag from "assets/images/flags/flat/luxembourg.png";
import macau_flag from "assets/images/flags/flat/macau.png";
import madagascar_flag from "assets/images/flags/flat/madagascar.png";
import madeira_flag from "assets/images/flags/flat/madeira.png";
import malawi_flag from "assets/images/flags/flat/malawi.png";
import malaysia_flag from "assets/images/flags/flat/malaysia.png";
import maldives_flag from "assets/images/flags/flat/maldives.png";
import mali_flag from "assets/images/flags/flat/mali.png";
import malta_flag from "assets/images/flags/flat/malta.png";
import mars_flag from "assets/images/flags/flat/mars.png";
import marshall_island_flag from "assets/images/flags/flat/marshall_island.png";
import martinique_flag from "assets/images/flags/flat/martinique.png";
import mauritania_flag from "assets/images/flags/flat/mauritania.png";
import mauritius_flag from "assets/images/flags/flat/mauritius.png";
import mayotte_flag from "assets/images/flags/flat/mayotte.png";
import melilla_flag from "assets/images/flags/flat/melilla.png";
import mexico_flag from "assets/images/flags/flat/mexico.png";
import micronesia_flag from "assets/images/flags/flat/micronesia.png";
import moldova_flag from "assets/images/flags/flat/moldova.png";
import monaco_flag from "assets/images/flags/flat/monaco.png";
import mongolia_flag from "assets/images/flags/flat/mongolia.png";
import montenegro_flag from "assets/images/flags/flat/montenegro.png";
import montserrat_flag from "assets/images/flags/flat/montserrat.png";
import morocco_flag from "assets/images/flags/flat/morocco.png";
import mozambique_flag from "assets/images/flags/flat/mozambique.png";
import myanmar_flag from "assets/images/flags/flat/myanmar.png";
import nagorno_karabakh_flag from "assets/images/flags/flat/nagorno_karabakh.png";
import namibia_flag from "assets/images/flags/flat/namibia.png";
import nato_flag from "assets/images/flags/flat/nato.png";
import nauru_flag from "assets/images/flags/flat/nauru.png";
import nepal_flag from "assets/images/flags/flat/nepal.png";
import netherlands_flag from "assets/images/flags/flat/netherlands.png";
import netherlands_antilles_flag from "assets/images/flags/flat/netherlands_antilles.png";
import new_caledonia_flag from "assets/images/flags/flat/new_caledonia.png";
import new_zealand_flag from "assets/images/flags/flat/new_zealand.png";
import nicaragua_flag from "assets/images/flags/flat/nicaragua.png";
import niger_flag from "assets/images/flags/flat/niger.png";
import nigeria_flag from "assets/images/flags/flat/nigeria.png";
import niue_flag from "assets/images/flags/flat/niue.png";
import norfolk_island_flag from "assets/images/flags/flat/norfolk_island.png";
import north_korea_flag from "assets/images/flags/flat/north_korea.png";
import north_macedonia_flag from "assets/images/flags/flat/north_macedonia.png";
import north_america_flag from "assets/images/flags/flat/north-america.png";
import northern_cyprus_flag from "assets/images/flags/flat/northern_cyprus.png";
import northern_marianas_islands_flag from "assets/images/flags/flat/northern_marianas_islands.png";
import northern_ireland_flag from "assets/images/flags/flat/northern-ireland.png";
import norway_flag from "assets/images/flags/flat/norway.png";
import oceania_flag from "assets/images/flags/flat/oceania.png";
import olympics_flag from "assets/images/flags/flat/olympics.png";
import oman_flag from "assets/images/flags/flat/oman.png";
import orkney_islands_flag from "assets/images/flags/flat/orkney_islands.png";
import ossetia_flag from "assets/images/flags/flat/ossetia.png";
import pakistan_flag from "assets/images/flags/flat/pakistan.png";
import palau_flag from "assets/images/flags/flat/palau.png";
import palestine_flag from "assets/images/flags/flat/palestine.png";
import panama_flag from "assets/images/flags/flat/panama.png";
import papua_new_guinea_flag from "assets/images/flags/flat/papua_new_guinea.png";
import paraguay_flag from "assets/images/flags/flat/paraguay.png";
import peru_flag from "assets/images/flags/flat/peru.png";
import philippines_flag from "assets/images/flags/flat/philippines.png";
import pitcairn_islands_flag from "assets/images/flags/flat/pitcairn_islands.png";
import poland_flag from "assets/images/flags/flat/poland.png";
import portugal_flag from "assets/images/flags/flat/portugal.png";
import puerto_rico_flag from "assets/images/flags/flat/puerto_rico.png";
import qatar_flag from "assets/images/flags/flat/qatar.png";
import rapa_nui_flag from "assets/images/flags/flat/rapa_nui.png";
import Red_Cross_flag from "assets/images/flags/flat/Red-Cross.png";
import republic_of_the_congo_flag from "assets/images/flags/flat/republic_of_the_congo.png";
import romania_flag from "assets/images/flags/flat/romania.png";
import rotterdam_flag from "assets/images/flags/flat/rotterdam.png";
import russia_flag from "assets/images/flags/flat/russia.png";
import rwanda_flag from "assets/images/flags/flat/rwanda.png";
import saba_island_flag from "assets/images/flags/flat/saba_island.png";
import sahrawi_arab_democratic_republic_flag from "assets/images/flags/flat/sahrawi_arab_democratic_republic.png";
import saint_barthelemy_flag from "assets/images/flags/flat/saint_barthelemy.png";
import saint_kitts_and_nevis_flag from "assets/images/flags/flat/saint_kitts_and_nevis.png";
import saint_lucia_flag from "assets/images/flags/flat/saint_lucia.png";
import saint_martin_flag from "assets/images/flags/flat/saint_martin.png";
import saint_vincent_and_the_grenadines_flag from "assets/images/flags/flat/saint_vincent_and_the_grenadines.png";
import Saint_Helena_flag from "assets/images/flags/flat/Saint-Helena.png";
import samoa_flag from "assets/images/flags/flat/samoa.png";
import san_marino_flag from "assets/images/flags/flat/san_marino.png";
import santiago_flag from "assets/images/flags/flat/santiago.png";
import sao_tome_and_principe_flag from "assets/images/flags/flat/sao_tome_and_principe.png";
import sardinia_flag from "assets/images/flags/flat/sardinia.png";
import saudi_arabia_flag from "assets/images/flags/flat/saudi_arabia.png";
import scotland_flag from "assets/images/flags/flat/scotland.png";
import senegal_flag from "assets/images/flags/flat/senegal.png";
import serbia_flag from "assets/images/flags/flat/serbia.png";
import seychelles_flag from "assets/images/flags/flat/seychelles.png";
import sierra_leone_flag from "assets/images/flags/flat/sierra_leone.png";
import singapore_flag from "assets/images/flags/flat/singapore.png";
import sint_eustatius_flag from "assets/images/flags/flat/sint_eustatius.png";
import sint_maarten_flag from "assets/images/flags/flat/sint_maarten.png";
import slovakia_flag from "assets/images/flags/flat/slovakia.png";
import slovenia_flag from "assets/images/flags/flat/slovenia.png";
import solomon_islands_flag from "assets/images/flags/flat/solomon_islands.png";
import somalia_flag from "assets/images/flags/flat/somalia.png";
import somaliland_flag from "assets/images/flags/flat/somaliland.png";
import south_africa_flag from "assets/images/flags/flat/south_africa.png";
import south_georgia_and_the_south_sandwich_islands_flag from "assets/images/flags/flat/south_georgia_and_the_south_sandwich_islands.png";
import south_korea_flag from "assets/images/flags/flat/south_korea.png";
import south_ossetia_flag from "assets/images/flags/flat/south_ossetia.png";
import south_sudan_flag from "assets/images/flags/flat/south_sudan.png";
import south_america_flag from "assets/images/flags/flat/south-america.png";
import spain_flag from "assets/images/flags/flat/spain.png";
import sri_lanka_flag from "assets/images/flags/flat/sri_lanka.png";
import sudan_flag from "assets/images/flags/flat/sudan.png";
import suriname_flag from "assets/images/flags/flat/suriname.png";
import swaziland_flag from "assets/images/flags/flat/swaziland.png";
import sweden_flag from "assets/images/flags/flat/sweden.png";
import switzerland_flag from "assets/images/flags/flat/switzerland.png";
import syria_flag from "assets/images/flags/flat/syria.png";
import taiwan_flag from "assets/images/flags/flat/taiwan.png";
import tajikistan_flag from "assets/images/flags/flat/tajikistan.png";
import tanzania_flag from "assets/images/flags/flat/tanzania.png";
import thailand_flag from "assets/images/flags/flat/thailand.png";
import tibet_flag from "assets/images/flags/flat/tibet.png";
import togo_flag from "assets/images/flags/flat/togo.png";
import tokelau_flag from "assets/images/flags/flat/tokelau.png";
import tonga_flag from "assets/images/flags/flat/tonga.png";
import transnistria_flag from "assets/images/flags/flat/transnistria.png";
import trinidad_and_tobago_flag from "assets/images/flags/flat/trinidad_and_tobago.png";
import tunisia_flag from "assets/images/flags/flat/tunisia.png";
import turkey_flag from "assets/images/flags/flat/turkey.png";
import turkmenistan_flag from "assets/images/flags/flat/turkmenistan.png";
import turks_and_caicos_islands_flag from "assets/images/flags/flat/turks_and_caicos_islands.png";
import tuvalu_flag from "assets/images/flags/flat/tuvalu.png";
import uganda_flag from "assets/images/flags/flat/uganda.png";
import ukraine_flag from "assets/images/flags/flat/ukraine.png";
import united_arab_emirates_flag from "assets/images/flags/flat/united_arab_emirates.png";
import united_kingdom_flag from "assets/images/flags/flat/united_kingdom.png";
import united_nations_flag from "assets/images/flags/flat/united_nations.png";
import united_states_flag from "assets/images/flags/flat/united_states.png";
import Unknown_flag from "assets/images/flags/flat/Unknown.png";
import uruguay_flag from "assets/images/flags/flat/uruguay.png";
import us_virgin_islands_flag from "assets/images/flags/flat/us_virgin_islands.png";
import uzbekistan_flag from "assets/images/flags/flat/uzbekistan.png";
import vanuatu_flag from "assets/images/flags/flat/vanuatu.png";
import vatican_city_flag from "assets/images/flags/flat/vatican_city.png";
import venezuela_flag from "assets/images/flags/flat/venezuela.png";
import vietnam_flag from "assets/images/flags/flat/vietnam.png";
import wales_flag from "assets/images/flags/flat/wales.png";
import wallis_and_futuna_flag from "assets/images/flags/flat/wallis_and_futuna.png";
import west_indies_flag from "assets/images/flags/flat/west_indies.png";
import western_sahara_flag from "assets/images/flags/flat/western_sahara.png";
import world_flag from "assets/images/flags/flat/world.png";
import world_grid_flag from "assets/images/flags/flat/world_grid.png";
import yemen_flag from "assets/images/flags/flat/yemen.png";
import zadar_flag from "assets/images/flags/flat/zadar.png";
import zambia_flag from "assets/images/flags/flat/zambia.png";
import zanzibar_flag from "assets/images/flags/flat/zanzibar.png";
import zimbabwe_flag from "assets/images/flags/flat/zimbabwe.png";


const flags = {
  ".abkhazia-flag": { backgroundImage: `url(${abkhazia_flag}) !important` },
  ".afghanistan-flag": { backgroundImage: `url(${afghanistan_flag}) !important` },
  ".africa-flag": { backgroundImage: `url(${africa_flag}) !important` },
  ".aland_islands-flag": { backgroundImage: `url(${aland_islands_flag}) !important` },
  ".albania-flag": { backgroundImage: `url(${albania_flag}) !important` },
  ".algeria-flag": { backgroundImage: `url(${algeria_flag}) !important` },
  ".america-flag": { backgroundImage: `url(${america_flag}) !important` },
  ".usa-flag": { backgroundImage: `url(${united_states_flag}) !important` },
  ".american_samoa-flag": { backgroundImage: `url(${american_samoa_flag}) !important` },
  ".andorra-flag": { backgroundImage: `url(${andorra_flag}) !important` },
  ".angola-flag": { backgroundImage: `url(${angola_flag}) !important` },
  ".anguilla-flag": { backgroundImage: `url(${anguilla_flag}) !important` },
  ".antarctica-flag": { backgroundImage: `url(${antarctica_flag}) !important` },
  ".antigua_and_barbuda-flag": { backgroundImage: `url(${antigua_and_barbuda_flag}) !important` },
  ".argentina-flag": { backgroundImage: `url(${argentina_flag}) !important` },
  ".armenia-flag": { backgroundImage: `url(${armenia_flag}) !important` },
  ".aruba-flag": { backgroundImage: `url(${aruba_flag}) !important` },
  ".asia-flag": { backgroundImage: `url(${asia_flag}) !important` },
  ".australia-flag": { backgroundImage: `url(${australia_flag}) !important` },
  ".austria-flag": { backgroundImage: `url(${austria_flag}) !important` },
  ".azerbaijan-flag": { backgroundImage: `url(${azerbaijan_flag}) !important` },
  ".azores_islands-flag": { backgroundImage: `url(${azores_islands_flag}) !important` },
  ".bahamas-flag": { backgroundImage: `url(${bahamas_flag}) !important` },
  ".bahrain-flag": { backgroundImage: `url(${bahrain_flag}) !important` },
  ".balearic_islands-flag": { backgroundImage: `url(${balearic_islands_flag}) !important` },
  ".bangladesh-flag": { backgroundImage: `url(${bangladesh_flag}) !important` },
  ".barbados-flag": { backgroundImage: `url(${barbados_flag}) !important` },
  ".basque_country-flag": { backgroundImage: `url(${basque_country_flag}) !important` },
  ".belarus-flag": { backgroundImage: `url(${belarus_flag}) !important` },
  ".belgium-flag": { backgroundImage: `url(${belgium_flag}) !important` },
  ".belize-flag": { backgroundImage: `url(${belize_flag}) !important` },
  ".benin-flag": { backgroundImage: `url(${benin_flag}) !important` },
  ".bermuda-flag": { backgroundImage: `url(${bermuda_flag}) !important` },
  ".bhutan-flag": { backgroundImage: `url(${bhutan_flag}) !important` },
  ".bolivia-flag": { backgroundImage: `url(${bolivia_flag}) !important` },
  ".bonaire-flag": { backgroundImage: `url(${bonaire_flag}) !important` },
  ".bosnia_and_herzegovina-flag": {
    backgroundImage: `url(${bosnia_and_herzegovina_flag}) !important`,
  },
  ".botswana-flag": { backgroundImage: `url(${botswana_flag}) !important` },
  ".brazil-flag": { backgroundImage: `url(${brazil_flag}) !important` },
  ".british_antarctic_territory-flag": {
    backgroundImage: `url(${british_antarctic_territory_flag}) !important`,
  },
  ".british_columbia-flag": { backgroundImage: `url(${british_columbia_flag}) !important` },
  ".british_indian_ocean_territory-flag": {
    backgroundImage: `url(${british_indian_ocean_territory_flag}) !important`,
  },
  ".british_virgin_islands-flag": {
    backgroundImage: `url(${british_virgin_islands_flag}) !important`,
  },
  ".brunei-flag": { backgroundImage: `url(${brunei_flag}) !important` },
  ".buenos_aires-flag": { backgroundImage: `url(${buenos_aires_flag}) !important` },
  ".bulgaria-flag": { backgroundImage: `url(${bulgaria_flag}) !important` },
  ".burkina_faso-flag": { backgroundImage: `url(${burkina_faso_flag}) !important` },
  ".burundi-flag": { backgroundImage: `url(${burundi_flag}) !important` },
  ".california-flag": { backgroundImage: `url(${california_flag}) !important` },
  ".cambodia-flag": { backgroundImage: `url(${cambodia_flag}) !important` },
  ".cameroon-flag": { backgroundImage: `url(${cameroon_flag}) !important` },
  ".canada-flag": { backgroundImage: `url(${canada_flag}) !important` },
  ".canary_islands-flag": { backgroundImage: `url(${canary_islands_flag}) !important` },
  ".cape_verde-flag": { backgroundImage: `url(${cape_verde_flag}) !important` },
  ".cayman_islands-flag": { backgroundImage: `url(${cayman_islands_flag}) !important` },
  ".central_african_republic-flag": {
    backgroundImage: `url(${central_african_republic_flag}) !important`,
  },
  ".central_america-flag": { backgroundImage: `url(${central_america_flag}) !important` },
  ".ceuta-flag": { backgroundImage: `url(${ceuta_flag}) !important` },
  ".chad-flag": { backgroundImage: `url(${chad_flag}) !important` },
  ".chile-flag": { backgroundImage: `url(${chile_flag}) !important` },
  ".china-flag": { backgroundImage: `url(${china_flag}) !important` },
  ".chinese_taipei-flag": { backgroundImage: `url(${chinese_taipei_flag}) !important` },
  ".christmas_island-flag": { backgroundImage: `url(${christmas_island_flag}) !important` },
  ".cocos_island-flag": { backgroundImage: `url(${cocos_island_flag}) !important` },
  ".colombia-flag": { backgroundImage: `url(${colombia_flag}) !important` },
  ".commonwealth-flag": { backgroundImage: `url(${commonwealth_flag}) !important` },
  ".comoros-flag": { backgroundImage: `url(${comoros_flag}) !important` },
  ".cook_islands-flag": { backgroundImage: `url(${cook_islands_flag}) !important` },
  ".corsica-flag": { backgroundImage: `url(${corsica_flag}) !important` },
  ".costa_rica-flag": { backgroundImage: `url(${costa_rica_flag}) !important` },
  ".cote_divoire-flag": { backgroundImage: `url(${cote_divoire_flag}) !important` },
  ".croatia-flag": { backgroundImage: `url(${croatia_flag}) !important` },
  ".cuba-flag": { backgroundImage: `url(${cuba_flag}) !important` },
  ".curacao-flag": { backgroundImage: `url(${curacao_flag}) !important` },
  ".cyprus-flag": { backgroundImage: `url(${cyprus_flag}) !important` },
  ".czech_republic-flag": { backgroundImage: `url(${czech_republic_flag}) !important` },
  ".democratic_republic_of_congo-flag": {
    backgroundImage: `url(${democratic_republic_of_congo_flag}) !important`,
  },
  ".denmark-flag": { backgroundImage: `url(${denmark_flag}) !important` },
  ".djibouti-flag": { backgroundImage: `url(${djibouti_flag}) !important` },
  ".dominica-flag": { backgroundImage: `url(${dominica_flag}) !important` },
  ".dominican_republic-flag": { backgroundImage: `url(${dominican_republic_flag}) !important` },
  ".east_timor-flag": { backgroundImage: `url(${east_timor_flag}) !important` },
  ".ecuador-flag": { backgroundImage: `url(${ecuador_flag}) !important` },
  ".egypt-flag": { backgroundImage: `url(${egypt_flag}) !important` },
  ".el_salvador-flag": { backgroundImage: `url(${el_salvador_flag}) !important` },
  ".england-flag": { backgroundImage: `url(${england_flag}) !important` },
  ".equatorial_guinea-flag": { backgroundImage: `url(${equatorial_guinea_flag}) !important` },
  ".eritrea-flag": { backgroundImage: `url(${eritrea_flag}) !important` },
  ".estonia-flag": { backgroundImage: `url(${estonia_flag}) !important` },
  ".ethiopia-flag": { backgroundImage: `url(${ethiopia_flag}) !important` },
  ".europe-flag": { backgroundImage: `url(${europe_flag}) !important` },
  ".european_union-flag": { backgroundImage: `url(${european_union_flag}) !important` },
  ".falkland_islands-flag": { backgroundImage: `url(${falkland_islands_flag}) !important` },
  ".faroe_islands-flag": { backgroundImage: `url(${faroe_islands_flag}) !important` },
  ".fiji-flag": { backgroundImage: `url(${fiji_flag}) !important` },
  ".finland-flag": { backgroundImage: `url(${finland_flag}) !important` },
  ".france-flag": { backgroundImage: `url(${france_flag}) !important` },
  ".french_polynesia-flag": { backgroundImage: `url(${french_polynesia_flag}) !important` },
  ".french_southern_territories-flag": {
    backgroundImage: `url(${french_southern_territories_flag}) !important`,
  },
  ".gabon-flag": { backgroundImage: `url(${gabon_flag}) !important` },
  ".galapagos_islands-flag": { backgroundImage: `url(${galapagos_islands_flag}) !important` },
  ".gambia-flag": { backgroundImage: `url(${gambia_flag}) !important` },
  ".georgia-flag": { backgroundImage: `url(${georgia_flag}) !important` },
  ".germany-flag": { backgroundImage: `url(${germany_flag}) !important` },
  ".ghana-flag": { backgroundImage: `url(${ghana_flag}) !important` },
  ".gibraltar-flag": { backgroundImage: `url(${gibraltar_flag}) !important` },
  ".GoSquared-flag": { backgroundImage: `url(${GoSquared_flag}) !important` },
  ".great_britain-flag": { backgroundImage: `url(${great_britain_flag}) !important` },
  ".greece-flag": { backgroundImage: `url(${greece_flag}) !important` },
  ".greenland-flag": { backgroundImage: `url(${greenland_flag}) !important` },
  ".grenada-flag": { backgroundImage: `url(${grenada_flag}) !important` },
  ".guadeloupe-flag": { backgroundImage: `url(${guadeloupe_flag}) !important` },
  ".guam-flag": { backgroundImage: `url(${guam_flag}) !important` },
  ".guatemala-flag": { backgroundImage: `url(${guatemala_flag}) !important` },
  ".guernsey-flag": { backgroundImage: `url(${guernsey_flag}) !important` },
  ".guinea-flag": { backgroundImage: `url(${guinea_flag}) !important` },
  ".guinea_bissau-flag": { backgroundImage: `url(${guinea_bissau_flag}) !important` },
  ".guyana-flag": { backgroundImage: `url(${guyana_flag}) !important` },
  ".haiti-flag": { backgroundImage: `url(${haiti_flag}) !important` },
  ".hawaii-flag": { backgroundImage: `url(${hawaii_flag}) !important` },
  ".honduras-flag": { backgroundImage: `url(${honduras_flag}) !important` },
  ".hong_kong-flag": { backgroundImage: `url(${hong_kong_flag}) !important` },
  ".hungary-flag": { backgroundImage: `url(${hungary_flag}) !important` },
  ".iceland-flag": { backgroundImage: `url(${iceland_flag}) !important` },
  ".india-flag": { backgroundImage: `url(${india_flag}) !important` },
  ".indonesia-flag": { backgroundImage: `url(${indonesia_flag}) !important` },
  ".international-flag": { backgroundImage: `url(${international_flag}) !important` },
  ".iran-flag": { backgroundImage: `url(${iran_flag}) !important` },
  ".iraq-flag": { backgroundImage: `url(${iraq_flag}) !important` },
  ".ireland-flag": { backgroundImage: `url(${ireland_flag}) !important` },
  ".republic_of_ireland-flag": { backgroundImage: `url(${ireland_flag}) !important` },
  ".isle_of_man-flag": { backgroundImage: `url(${isle_of_man_flag}) !important` },
  ".israel-flag": { backgroundImage: `url(${israel_flag}) !important` },
  ".italy-flag": { backgroundImage: `url(${italy_flag}) !important` },
  ".ivory_coast-flag": { backgroundImage: `url(${ivory_coast_flag}) !important` },
  ".jamaica-flag": { backgroundImage: `url(${jamaica_flag}) !important` },
  ".japan-flag": { backgroundImage: `url(${japan_flag}) !important` },
  ".jersey-flag": { backgroundImage: `url(${jersey_flag}) !important` },
  ".jordan-flag": { backgroundImage: `url(${jordan_flag}) !important` },
  ".kazakhstan-flag": { backgroundImage: `url(${kazakhstan_flag}) !important` },
  ".kenya-flag": { backgroundImage: `url(${kenya_flag}) !important` },
  ".kiribati-flag": { backgroundImage: `url(${kiribati_flag}) !important` },
  ".kosovo-flag": { backgroundImage: `url(${kosovo_flag}) !important` },
  ".kuwait-flag": { backgroundImage: `url(${kuwait_flag}) !important` },
  ".kyrgyzstan-flag": { backgroundImage: `url(${kyrgyzstan_flag}) !important` },
  ".laos-flag": { backgroundImage: `url(${laos_flag}) !important` },
  ".latvia-flag": { backgroundImage: `url(${latvia_flag}) !important` },
  ".lebanon-flag": { backgroundImage: `url(${lebanon_flag}) !important` },
  ".lesotho-flag": { backgroundImage: `url(${lesotho_flag}) !important` },
  ".liberia-flag": { backgroundImage: `url(${liberia_flag}) !important` },
  ".libya-flag": { backgroundImage: `url(${libya_flag}) !important` },
  ".liechtenstein-flag": { backgroundImage: `url(${liechtenstein_flag}) !important` },
  ".lithuania-flag": { backgroundImage: `url(${lithuania_flag}) !important` },
  ".luxembourg-flag": { backgroundImage: `url(${luxembourg_flag}) !important` },
  ".macau-flag": { backgroundImage: `url(${macau_flag}) !important` },
  ".madagascar-flag": { backgroundImage: `url(${madagascar_flag}) !important` },
  ".madeira-flag": { backgroundImage: `url(${madeira_flag}) !important` },
  ".malawi-flag": { backgroundImage: `url(${malawi_flag}) !important` },
  ".malaysia-flag": { backgroundImage: `url(${malaysia_flag}) !important` },
  ".maldives-flag": { backgroundImage: `url(${maldives_flag}) !important` },
  ".mali-flag": { backgroundImage: `url(${mali_flag}) !important` },
  ".malta-flag": { backgroundImage: `url(${malta_flag}) !important` },
  ".mars-flag": { backgroundImage: `url(${mars_flag}) !important` },
  ".marshall_island-flag": { backgroundImage: `url(${marshall_island_flag}) !important` },
  ".martinique-flag": { backgroundImage: `url(${martinique_flag}) !important` },
  ".mauritania-flag": { backgroundImage: `url(${mauritania_flag}) !important` },
  ".mauritius-flag": { backgroundImage: `url(${mauritius_flag}) !important` },
  ".mayotte-flag": { backgroundImage: `url(${mayotte_flag}) !important` },
  ".melilla-flag": { backgroundImage: `url(${melilla_flag}) !important` },
  ".mexico-flag": { backgroundImage: `url(${mexico_flag}) !important` },
  ".micronesia-flag": { backgroundImage: `url(${micronesia_flag}) !important` },
  ".moldova-flag": { backgroundImage: `url(${moldova_flag}) !important` },
  ".monaco-flag": { backgroundImage: `url(${monaco_flag}) !important` },
  ".mongolia-flag": { backgroundImage: `url(${mongolia_flag}) !important` },
  ".montenegro-flag": { backgroundImage: `url(${montenegro_flag}) !important` },
  ".montserrat-flag": { backgroundImage: `url(${montserrat_flag}) !important` },
  ".morocco-flag": { backgroundImage: `url(${morocco_flag}) !important` },
  ".mozambique-flag": { backgroundImage: `url(${mozambique_flag}) !important` },
  ".myanmar-flag": { backgroundImage: `url(${myanmar_flag}) !important` },
  ".nagorno_karabakh-flag": { backgroundImage: `url(${nagorno_karabakh_flag}) !important` },
  ".namibia-flag": { backgroundImage: `url(${namibia_flag}) !important` },
  ".nato-flag": { backgroundImage: `url(${nato_flag}) !important` },
  ".nauru-flag": { backgroundImage: `url(${nauru_flag}) !important` },
  ".nepal-flag": { backgroundImage: `url(${nepal_flag}) !important` },
  ".netherlands-flag": { backgroundImage: `url(${netherlands_flag}) !important` },
  ".netherlands_antilles-flag": { backgroundImage: `url(${netherlands_antilles_flag}) !important` },
  ".new_caledonia-flag": { backgroundImage: `url(${new_caledonia_flag}) !important` },
  ".new_zealand-flag": { backgroundImage: `url(${new_zealand_flag}) !important` },
  ".nicaragua-flag": { backgroundImage: `url(${nicaragua_flag}) !important` },
  ".niger-flag": { backgroundImage: `url(${niger_flag}) !important` },
  ".nigeria-flag": { backgroundImage: `url(${nigeria_flag}) !important` },
  ".niue-flag": { backgroundImage: `url(${niue_flag}) !important` },
  ".norfolk_island-flag": { backgroundImage: `url(${norfolk_island_flag}) !important` },
  ".north_korea-flag": { backgroundImage: `url(${north_korea_flag}) !important` },
  ".north_macedonia-flag": { backgroundImage: `url(${north_macedonia_flag}) !important` },
  ".north_america-flag": { backgroundImage: `url(${north_america_flag}) !important` },
  ".northern_cyprus-flag": { backgroundImage: `url(${northern_cyprus_flag}) !important` },
  ".northern_marianas_islands-flag": {
    backgroundImage: `url(${northern_marianas_islands_flag}) !important`,
  },
  ".northern_ireland-flag": { backgroundImage: `url(${northern_ireland_flag}) !important` },
  ".norway-flag": { backgroundImage: `url(${norway_flag}) !important` },
  ".oceania-flag": { backgroundImage: `url(${oceania_flag}) !important` },
  ".olympics-flag": { backgroundImage: `url(${olympics_flag}) !important` },
  ".oman-flag": { backgroundImage: `url(${oman_flag}) !important` },
  ".orkney_islands-flag": { backgroundImage: `url(${orkney_islands_flag}) !important` },
  ".ossetia-flag": { backgroundImage: `url(${ossetia_flag}) !important` },
  ".pakistan-flag": { backgroundImage: `url(${pakistan_flag}) !important` },
  ".palau-flag": { backgroundImage: `url(${palau_flag}) !important` },
  ".palestine-flag": { backgroundImage: `url(${palestine_flag}) !important` },
  ".panama-flag": { backgroundImage: `url(${panama_flag}) !important` },
  ".papua_new_guinea-flag": { backgroundImage: `url(${papua_new_guinea_flag}) !important` },
  ".paraguay-flag": { backgroundImage: `url(${paraguay_flag}) !important` },
  ".peru-flag": { backgroundImage: `url(${peru_flag}) !important` },
  ".philippines-flag": { backgroundImage: `url(${philippines_flag}) !important` },
  ".pitcairn_islands-flag": { backgroundImage: `url(${pitcairn_islands_flag}) !important` },
  ".poland-flag": { backgroundImage: `url(${poland_flag}) !important` },
  ".portugal-flag": { backgroundImage: `url(${portugal_flag}) !important` },
  ".puerto_rico-flag": { backgroundImage: `url(${puerto_rico_flag}) !important` },
  ".qatar-flag": { backgroundImage: `url(${qatar_flag}) !important` },
  ".rapa_nui-flag": { backgroundImage: `url(${rapa_nui_flag}) !important` },
  ".Red_Cross-flag": { backgroundImage: `url(${Red_Cross_flag}) !important` },
  ".republic_of_the_congo-flag": {
    backgroundImage: `url(${republic_of_the_congo_flag}) !important`,
  },
  ".romania-flag": { backgroundImage: `url(${romania_flag}) !important` },
  ".rotterdam-flag": { backgroundImage: `url(${rotterdam_flag}) !important` },
  ".russia-flag": { backgroundImage: `url(${russia_flag}) !important` },
  ".rwanda-flag": { backgroundImage: `url(${rwanda_flag}) !important` },
  ".saba_island-flag": { backgroundImage: `url(${saba_island_flag}) !important` },
  ".sahrawi_arab_democratic_republic-flag": {
    backgroundImage: `url(${sahrawi_arab_democratic_republic_flag}) !important`,
  },
  ".saint_barthelemy-flag": { backgroundImage: `url(${saint_barthelemy_flag}) !important` },
  ".saint_kitts_and_nevis-flag": {
    backgroundImage: `url(${saint_kitts_and_nevis_flag}) !important`,
  },
  ".saint_lucia-flag": { backgroundImage: `url(${saint_lucia_flag}) !important` },
  ".saint_martin-flag": { backgroundImage: `url(${saint_martin_flag}) !important` },
  ".saint_vincent_and_the_grenadines-flag": {
    backgroundImage: `url(${saint_vincent_and_the_grenadines_flag}) !important`,
  },
  ".Saint_Helena-flag": { backgroundImage: `url(${Saint_Helena_flag}) !important` },
  ".samoa-flag": { backgroundImage: `url(${samoa_flag}) !important` },
  ".san_marino-flag": { backgroundImage: `url(${san_marino_flag}) !important` },
  ".santiago-flag": { backgroundImage: `url(${santiago_flag}) !important` },
  ".sao_tome_and_principe-flag": {
    backgroundImage: `url(${sao_tome_and_principe_flag}) !important`,
  },
  ".sardinia-flag": { backgroundImage: `url(${sardinia_flag}) !important` },
  ".saudi_arabia-flag": { backgroundImage: `url(${saudi_arabia_flag}) !important` },
  ".scotland-flag": { backgroundImage: `url(${scotland_flag}) !important` },
  ".senegal-flag": { backgroundImage: `url(${senegal_flag}) !important` },
  ".serbia-flag": { backgroundImage: `url(${serbia_flag}) !important` },
  ".seychelles-flag": { backgroundImage: `url(${seychelles_flag}) !important` },
  ".sierra_leone-flag": { backgroundImage: `url(${sierra_leone_flag}) !important` },
  ".singapore-flag": { backgroundImage: `url(${singapore_flag}) !important` },
  ".sint_eustatius-flag": { backgroundImage: `url(${sint_eustatius_flag}) !important` },
  ".sint_maarten-flag": { backgroundImage: `url(${sint_maarten_flag}) !important` },
  ".slovakia-flag": { backgroundImage: `url(${slovakia_flag}) !important` },
  ".slovenia-flag": { backgroundImage: `url(${slovenia_flag}) !important` },
  ".solomon_islands-flag": { backgroundImage: `url(${solomon_islands_flag}) !important` },
  ".somalia-flag": { backgroundImage: `url(${somalia_flag}) !important` },
  ".somaliland-flag": { backgroundImage: `url(${somaliland_flag}) !important` },
  ".south_africa-flag": { backgroundImage: `url(${south_africa_flag}) !important` },
  ".south_georgia_and_the_south_sandwich_islands-flag": {
    backgroundImage: `url(${south_georgia_and_the_south_sandwich_islands_flag}) !important`,
  },
  ".south_korea-flag": { backgroundImage: `url(${south_korea_flag}) !important` },
  ".south_ossetia-flag": { backgroundImage: `url(${south_ossetia_flag}) !important` },
  ".south_sudan-flag": { backgroundImage: `url(${south_sudan_flag}) !important` },
  ".south_america-flag": { backgroundImage: `url(${south_america_flag}) !important` },
  ".spain-flag": { backgroundImage: `url(${spain_flag}) !important` },
  ".sri_lanka-flag": { backgroundImage: `url(${sri_lanka_flag}) !important` },
  ".sudan-flag": { backgroundImage: `url(${sudan_flag}) !important` },
  ".suriname-flag": { backgroundImage: `url(${suriname_flag}) !important` },
  ".swaziland-flag": { backgroundImage: `url(${swaziland_flag}) !important` },
  ".sweden-flag": { backgroundImage: `url(${sweden_flag}) !important` },
  ".switzerland-flag": { backgroundImage: `url(${switzerland_flag}) !important` },
  ".syria-flag": { backgroundImage: `url(${syria_flag}) !important` },
  ".taiwan-flag": { backgroundImage: `url(${taiwan_flag}) !important` },
  ".tajikistan-flag": { backgroundImage: `url(${tajikistan_flag}) !important` },
  ".tanzania-flag": { backgroundImage: `url(${tanzania_flag}) !important` },
  ".united_republic_of_tanzania-flag": { backgroundImage: `url(${tanzania_flag}) !important` },
  ".thailand-flag": { backgroundImage: `url(${thailand_flag}) !important` },
  ".tibet-flag": { backgroundImage: `url(${tibet_flag}) !important` },
  ".togo-flag": { backgroundImage: `url(${togo_flag}) !important` },
  ".tokelau-flag": { backgroundImage: `url(${tokelau_flag}) !important` },
  ".tonga-flag": { backgroundImage: `url(${tonga_flag}) !important` },
  ".transnistria-flag": { backgroundImage: `url(${transnistria_flag}) !important` },
  ".trinidad_and_tobago-flag": { backgroundImage: `url(${trinidad_and_tobago_flag}) !important` },
  ".tunisia-flag": { backgroundImage: `url(${tunisia_flag}) !important` },
  ".turkey-flag": { backgroundImage: `url(${turkey_flag}) !important` },
  ".turkmenistan-flag": { backgroundImage: `url(${turkmenistan_flag}) !important` },
  ".turks_and_caicos_islands-flag": {
    backgroundImage: `url(${turks_and_caicos_islands_flag}) !important`,
  },
  ".tuvalu-flag": { backgroundImage: `url(${tuvalu_flag}) !important` },
  ".uganda-flag": { backgroundImage: `url(${uganda_flag}) !important` },
  ".ukraine-flag": { backgroundImage: `url(${ukraine_flag}) !important` },
  ".united_arab_emirates-flag": { backgroundImage: `url(${united_arab_emirates_flag}) !important` },
  ".united_kingdom-flag": { backgroundImage: `url(${united_kingdom_flag}) !important` },
  ".united_nations-flag": { backgroundImage: `url(${united_nations_flag}) !important` },
  ".united_states-flag": { backgroundImage: `url(${united_states_flag}) !important` },
  ".Unknown-flag": { backgroundImage: `url(${Unknown_flag}) !important` },
  ".uruguay-flag": { backgroundImage: `url(${uruguay_flag}) !important` },
  ".us_virgin_islands-flag": { backgroundImage: `url(${us_virgin_islands_flag}) !important` },
  ".uzbekistan-flag": { backgroundImage: `url(${uzbekistan_flag}) !important` },
  ".vanuatu-flag": { backgroundImage: `url(${vanuatu_flag}) !important` },
  ".vatican_city-flag": { backgroundImage: `url(${vatican_city_flag}) !important` },
  ".venezuela-flag": { backgroundImage: `url(${venezuela_flag}) !important` },
  ".vietnam-flag": { backgroundImage: `url(${vietnam_flag}) !important` },
  ".wales-flag": { backgroundImage: `url(${wales_flag}) !important` },
  ".wallis_and_futuna-flag": { backgroundImage: `url(${wallis_and_futuna_flag}) !important` },
  ".west_indies-flag": { backgroundImage: `url(${west_indies_flag}) !important` },
  ".western_sahara-flag": { backgroundImage: `url(${western_sahara_flag}) !important` },
  ".world-flag": { backgroundImage: `url(${world_flag}) !important` },
  ".world_grid-flag": { backgroundImage: `url(${world_grid_flag}) !important` },
  ".yemen-flag": { backgroundImage: `url(${yemen_flag}) !important` },
  ".zadar-flag": { backgroundImage: `url(${zadar_flag}) !important` },
  ".zambia-flag": { backgroundImage: `url(${zambia_flag}) !important` },
  ".zanzibar-flag": { backgroundImage: `url(${zanzibar_flag}) !important` },
  ".zimbabwe-flag": { backgroundImage: `url(${zimbabwe_flag}) !important` },

  ".flag-round": {
    backgroundImage: `url(${default_flag})`,
    height: "20px",
    width: "20px",
    display: "inline-flex",
    backgroundSize: "20px 20px",
    marginRight: "5px",
    borderRadius: "15px",
    backgroundColor: "#cecece",
    lineHeight: "70px",
    boxShadow: "1px 1px 2px #cecece",
  },
};

export default flags;
